import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'contact-library.field-1-name': {
    id: 'contact-library.field-1-name',
    defaultMessage: 'Profile image',
    description:
      'The field name (and the default value/watermark) in field #1 for this database template. In this case: Profile image',
  },
  'contact-library.field-2-name': {
    id: 'contact-library.field-2-name',
    defaultMessage: 'Name',
    description:
      'The field name (and the default value/watermark) in field #2 for this database template. In this case: Name',
  },
  'contact-library.field-3-name': {
    id: 'contact-library.field-3-name',
    defaultMessage: 'Role',
    description:
      'The field name (and the default value/watermark) in field #3 for this database template. In this case: Role',
  },
  'contact-library.field-4-name': {
    id: 'contact-library.field-4-name',
    defaultMessage: 'Email',
    description:
      'The field name (and the default value/watermark) in field #4 for this database template. In this case: Email',
  },
  'contact-library.field-5-name': {
    id: 'contact-library.field-5-name',
    defaultMessage: 'Industry',
    description:
      'The field name (and the default value/watermark) in field #5 for this database template. In this case: Industry',
  },
  'contact-library.field-5-select-option-1': {
    id: 'contact-library.field-5-select-option-1',
    defaultMessage: 'eCommerce',
    description:
      'The option value for option #1 in field #5 for this database template. In this case: eCommerce',
  },
  'contact-library.field-5-select-option-2': {
    id: 'contact-library.field-5-select-option-2',
    defaultMessage: 'Technology',
    description:
      'The option value for option #2 in field #5 for this database template. In this case: Technology',
  },
  'contact-library.field-5-select-option-3': {
    id: 'contact-library.field-5-select-option-3',
    defaultMessage: 'Cybersecurity',
    description:
      'The option value for option #3 in field #5 for this database template. In this case: Cybersecurity',
  },
  'contact-library.field-6-name': {
    id: 'contact-library.field-6-name',
    defaultMessage: 'Description',
    description:
      'The field name (and the default value/watermark) in field #6 for this database template. In this case: Description',
  },
  'contact-library.view-1-name': {
    id: 'contact-library.view-1-name',
    defaultMessage: 'All contacts',
    description:
      'The view name for view #1 in this template. Displayed on the top left of the screen (bellow the database name). In this case: All contacts',
  },
  'contact-library.entry-1-cell-3': {
    id: 'contact-library.entry-1-cell-3',
    defaultMessage: 'CEO',
    description:
      'The text value of cell #3 in row (entry) #1 in this database template. In this case:  CEO',
  },
  'contact-library.entry-1-cell-4': {
    id: 'contact-library.entry-1-cell-4',
    defaultMessage: 'annieclare@ideathread.com',
    description:
      'The text value of cell #4 in row (entry) #1 in this database template. In this case:  annieclare@ideathread.com',
  },
  'contact-library.entry-1-cell-6': {
    id: 'contact-library.entry-1-cell-6',
    defaultMessage:
      'Annie Clare is the CEO of Idea Thread, a custom apparel company with a built-in marketplace that donates a portion of profits to good causes. Passionate about empowering women in business, Annie also mentors aspiring entrepreneurs.',
    description:
      'The text value of cell #6 in row (entry) #1 in this database template. In this case:  Annie Clare is the CEO of Idea Thread, a custom apparel company with a built-in marketplace that donates a portion of profits to good causes. Passionate about empowering women in business, Annie also mentors aspiring entrepreneurs.',
  },
  'contact-library.entry-2-cell-3': {
    id: 'contact-library.entry-2-cell-3',
    defaultMessage: 'Tech Strategist',
    description:
      'The text value of cell #3 in row (entry) #2 in this database template. In this case:  Tech Strategist',
  },
  'contact-library.entry-2-cell-4': {
    id: 'contact-library.entry-2-cell-4',
    defaultMessage: 'austinlambert@prosperifyinvestments.com',
    description:
      'The text value of cell #4 in row (entry) #2 in this database template. In this case:  austinlambert@prosperifyinvestments.com',
  },
  'contact-library.entry-2-cell-6': {
    id: 'contact-library.entry-2-cell-6',
    defaultMessage:
      'Austin Lambert is a tech strategist with a background in consulting and emerging technologies. At his firm, he guides organizations through digital transformation, often sharing insights at conferences on aligning tech with business goals.',
    description:
      'The text value of cell #6 in row (entry) #2 in this database template. In this case:  Austin Lambert is a tech strategist with a background in consulting and emerging technologies. At his firm, he guides organizations through digital transformation, often sharing insights at conferences on aligning tech with business goals.',
  },
  'contact-library.entry-3-cell-3': {
    id: 'contact-library.entry-3-cell-3',
    defaultMessage: 'Cybersecurity Strategist',
    description:
      'The text value of cell #3 in row (entry) #3 in this database template. In this case:  Cybersecurity Strategist',
  },
  'contact-library.entry-3-cell-4': {
    id: 'contact-library.entry-3-cell-4',
    defaultMessage: 'oliviayang@nscia.com',
    description:
      'The text value of cell #4 in row (entry) #3 in this database template. In this case:  oliviayang@nscia.com',
  },
  'contact-library.entry-3-cell-6': {
    id: 'contact-library.entry-3-cell-6',
    defaultMessage:
      'Olivia Yang is a cybersecurity expert with a background in risk management and digital defense. Known for her strategic approach, she works to protect organizations against evolving cyber threats and frequently shares insights on cybersecurity best practices at industry events.',
    description:
      'The text value of cell #6 in row (entry) #3 in this database template. In this case:  Olivia Yang is a cybersecurity expert with a background in risk management and digital defense. Known for her strategic approach, she works to protect organizations against evolving cyber threats and frequently shares insights on cybersecurity best practices at industry events.',
  },
  'contact-library.entry-4-cell-3': {
    id: 'contact-library.entry-4-cell-3',
    defaultMessage: 'AI Expert',
    description:
      'The text value of cell #3 in row (entry) #4 in this database template. In this case:  AI Expert',
  },
  'contact-library.entry-4-cell-4': {
    id: 'contact-library.entry-4-cell-4',
    defaultMessage: 'fidelisejima@thrive4tomorrow.com',
    description:
      'The text value of cell #4 in row (entry) #4 in this database template. In this case:  fidelisejima@thrive4tomorrow.com',
  },
  'contact-library.entry-4-cell-6': {
    id: 'contact-library.entry-4-cell-6',
    defaultMessage:
      'Fidelis Ejima is a seasoned AI communications expert with a background in technology and public relations. As spokesperson for his company, he brings years of experience in making complex AI concepts accessible to diverse audiences. At conferences, Fidelis shares insights on the company’s innovations and the broader impact of AI on society.',
    description:
      'The text value of cell #6 in row (entry) #4 in this database template. In this case:  Fidelis Ejima is a seasoned AI communications expert with a background in technology and public relations. As spokesperson for his company, he brings years of experience in making complex AI concepts accessible to diverse audiences. At conferences, Fidelis shares insights on the company’s innovations and the broader impact of AI on society.',
  },
});
